import React from 'react'

import { InfoItem, InfoText } from '../client-details'
import SharedStack from '~components/shared/wrappers/shared-stack'
import AppointmentStatusTag from '~components/shared/appointment-status-tag'
import { AppointmentFieldsFragment } from '~graphql/generated/graphql'
import { format } from 'date-fns'
import { Avatar } from '@chakra-ui/react'

interface Props {
    appointment?: AppointmentFieldsFragment | null | undefined
}

export default function AppointmentDetails({ appointment }: Props) {
    return (
        <SharedStack spacing={4}>
            <InfoItem label="Patient">
                {appointment?.patient ? (
                    <SharedStack row fit>
                        <Avatar
                            size="xs"
                            name={appointment.patient?.name || 'Unknown'}
                            w="18px"
                            h="18px"
                            fontSize="13px"
                        />
                        <InfoText>{appointment.patient?.name}</InfoText>
                    </SharedStack>
                ) : (
                    <InfoText />
                )}
            </InfoItem>
            <InfoItem label="Service">
                <InfoText>
                    {appointment?.service?.name || appointment?.service_name}
                </InfoText>
            </InfoItem>
            <InfoItem label="Clinician">
                <InfoText>{appointment?.clinician?.name}</InfoText>
            </InfoItem>
            <InfoItem label="Date">
                <InfoText>
                    {appointment?.start_time
                        ? format(appointment?.start_time, 'PPP, p')
                        : undefined}
                </InfoText>
            </InfoItem>
            <InfoItem label="Status">
                {appointment ? (
                    <SharedStack row fit align="center">
                        <AppointmentStatusTag
                            appointment={appointment}
                            size="sm"
                            shouldDisableTooltip
                        />
                        <InfoText>{appointment.status}</InfoText>
                    </SharedStack>
                ) : (
                    <InfoText />
                )}
            </InfoItem>
        </SharedStack>
    )
}
